import { Injectable, inject } from "@angular/core";
import { CsvService } from "./csv.service";
import * as XLSX from "xlsx";

@Injectable({
    providedIn: 'root'
  })
export class ExcelExportService {
    csvService = inject(CsvService);

    constructor() { }

    exportExcelFile(jsonData: any):void {
        /* fetch JSON data and parse */
        
        const raw_data = jsonData;
      
        /* filter for the Presidents */
        
      
        /* sort by first presidential term */
        
      
        /* flatten objects */
        
      
        /* generate worksheet and workbook */
        
        const worksheet = XLSX.utils.json_to_sheet(raw_data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Driver List");
      
        /* fix headers */
        
        XLSX.utils.sheet_add_aoa(worksheet, [["Driver's Apex ID", "Driver's Full Name", "Terminal ID", "Terminal Name", "Sub Region", "Country/Region", "Read Time"]], { origin: "A1" });

        /* calculate column width */
        
        const max_width = 27;
        worksheet["!cols"] = [ { wch: max_width }, { wch: max_width }, { wch: 10 }, { wch: max_width }, { wch: max_width }, { wch: 16 }, { wch: max_width } ];

        /* create an XLSX file and try to save to Presidents.xlsx */
        XLSX.writeFile(workbook, "Driver List.xlsx", { compression: true });
      }
}